import Box from '@ff/ui/Box';
import React from 'react';
import { styled } from '@ff/ui';
import Button from '@ff/ui/Button';
import Text from '@ff/ui/Text';

export default function ComingSoonRedirectMessage({ isApp }) {
  return (
    <Container>
      <Box>
        {
          isApp ? (
            <>
              <Text fontSize="28px" textAlign="center">
                Preorder now
              </Text>
              <Text fontSize="14px" textAlign="center" marginTop="5px">
                Please visit www.ff.com
              </Text>
            </>
          ) : (
          <>
            <Box display="flex" justifyContent="center">
              <UnstyledButton variant='dark' onClick={() => { window.location.href="/us/preorder"; }}>
                <Text fontSize="28px">
                  Preorder Now
                </Text>
              </UnstyledButton>
            </Box>
          </>
          )
        }
        <Text fontSize="25px" line-height="34px" fontWeight={300} fontFamily="Roboto" padding="40px 24px 10px 24px" textAlign="center">
          {'A new Preorder experience is coming soon!'}
        </Text>
        <Text fontSize="16px" fontWeight={400} textAlign="center">
          {`2023.5.30 8:00 PM PT`}
        </Text> 
      </Box>
    </Container>
  );
}

const UnstyledButton = styled(Button)({
  background: 'none',
  border: 'none',
  color: 'black',
  textDecoration: 'underline',
  '&:hover': {
    background: 'none',
  }
})

const Container = styled(Box)(({ theme }) => ({
  background: 'url(https://genesis-cdn.ff.com/assets/pages/ff-91/new-coming-soon2-default.jpg)',
  backgroundColor: "white",
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  flexDirection: "column",
  display:"flex",
  justifyContent: "start",
  paddingTop: '15vh',
  minHeight: "calc(100vh - 40px)",
  [theme.mediaQueries.md]: {
    backgroundSize: 'cover',
  },
}));
